import React from 'react';

function DollarViewIcon({ ...props }) {
    return (
        <svg
            width="16"
            height="19"
            viewBox="0 0 16 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M10.9551 11.0087V3.1681H1M1 3.1681V13.6595M1 3.1681V2.20816C1 1.54091 1.58689 1 2.31087 1H9.64422C10.3682 1 10.9551 1.54091 10.9551 2.20816V3.1681H1ZM1 13.6595H7.38564M1 13.6595V14.8783C1 15.5455 1.58689 16.0865 2.31087 16.0865H7.84298"
                stroke="black"
                strokeWidth="0.8"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.4769 16.6749C14.87 15.3909 14.87 13.3091 13.4768 12.0251C12.0836 10.7411 9.82483 10.7411 8.43169 12.0251C7.03854 13.3092 7.03858 15.391 8.43178 16.675C9.82497 17.959 12.0837 17.9589 13.4769 16.6749Z"
                stroke="black"
                strokeWidth="0.8"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.77791 14.3621L10.5544 15.0777L12.1332 13.6226M6.87981 6.70328C6.61524 6.56009 5.97804 6.29854 5.48613 6.48667C4.82707 6.73869 4.70845 7.42545 5.17984 7.86387C5.47298 8.13654 5.7955 8.18534 6.33156 8.37285C7.00145 8.6072 7.2431 9.14304 7.08535 9.63752C6.95089 10.059 6.51029 10.3655 5.92007 10.3655C5.55737 10.3655 5.15613 10.256 4.82422 10.0501M5.97688 10.4259V10.9396M5.97688 5.88794V6.37576"
                stroke="black"
                strokeWidth="0.8"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default DollarViewIcon;
